// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__9axc-","notes":"Notes_notes__K8oLY","note":"Notes_note__1Qx1C","markdown":"Notes_markdown__2IXk7"};